import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { isClientsOnlySession } from '@/lib/access-state';

export function useClientsOnlySession(): boolean {
  const { serverUser } = useAuth();
  return isClientsOnlySession(serverUser?.roles);
}

/**
 * Clients-only sessions do not get practitioner Select/Create client.
 * Send them to the public photo flow instead.
 */
export function ClientsOnlyAppWall() {
  return (
    <div className="mx-auto flex w-full max-w-lg flex-col gap-4 py-4">
      <h1 className="text-2xl font-semibold text-foreground">Practitioner app only</h1>
      <p className="text-muted-foreground">
        This sign-in is for the practitioner app. Your account is set up as a client.
      </p>
      <Button asChild className="h-11 w-full sm:w-auto">
        <Link to="/self-assessment">Open the client experience</Link>
      </Button>
    </div>
  );
}
